<template>
  <single-panel-page>
    <h5>Reset password</h5>

    <div v-show="!messageSent" class="row">
      <div class="col-sm-12">
        <p class="text-muted text-sm">
          You can click button below in order to retrieve your forgotten
          password. We will send you an e-mail message with a link that would
          allow you to perform one-time password change.
        </p>
      </div>
    </div>

    <div v-show="messageSent" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-success">
          Message has been sent to your e-mail address: {{ user.email }}.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-right">
        <button
          v-show="!messageSent"
          class="btn btn-block btn-primary text-uppercase"
          :disabled="inProgress"
          @click="submit()"
        >
          <span>Send message</span>
        </button>
      </div>
    </div>

    <div class="row change-password-link-wrapper">
      <div class="col-sm-12">
        <router-link class="text-sm" :to="{ name: 'changePasswordPage' }">
          Change password form
        </router-link>
      </div>
    </div>

    <div slot="bottom">
      <span class="splash-box-footer">
        <router-link class="text-yellow" :to="dashboardRoute"
          >Back to app</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { mapState, mapGetters } from 'vuex'
import { sleep } from 'utils'

export default {
  data() {
    return {
      inProgress: false,
      messageSent: false,
      email: '',
    }
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
    }),
    ...mapGetters({
      dashboardRoute: 'user/dashboardRoute',
    }),
  },

  created() {
    this.$store.dispatch('user/fetchNoRedirect')
  },

  methods: {
    async submit() {
      this.inProgress = true
      const email = this.user.email
      console.log(' => requesting password reset with email:', email)
      const request = Auth.requestPasswordReset({ email })
      await sleep(2000)
      try {
        const response = await request
        this.messageSent = true
      } finally {
        this.inProgress = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.splash-box {
  .change-password-link-wrapper {
    margin-top: 10px;
  }
}
</style>
